import React from 'react';
import { ChevronDown, Star } from 'lucide-react';
import { NavItem } from './NavItem';
import { MODULES_BY_NAME, ersattAvAnbudV2 } from '../../data/modules';
import { useAuth } from '../../auth/AuthProvider';
import { arSystemadminUtanSimulering } from '../../utils/systemadminVy';

export function FavoritesSection({
  favorites,
  collapsed,
  onToggleCollapse,
  onToggleFavorite,
  unreadCounts,
  effectiveModuleKeySet = null,
  isSystemAdmin = false,
  isTenantAdmin = false,
}) {
  const { user } = useAuth() || {};
  const sectionClass = [
    'kp-nav-section',
    'kp-nav-section--favorites',
    collapsed ? 'kp-nav-section--collapsed' : '',
  ].filter(Boolean).join(' ');

  // Filtrera favoriter mot samma åtkomstregler som NavSection så att favoriter
  // inte läcker moduler som användaren saknar rättigheter till (t.ex. om en
  // annan användare loggat in i samma webbläsare tidigare).
  const visaPersonliga = arSystemadminUtanSimulering(user);
  const items = favorites
    .map((name) => MODULES_BY_NAME[name])
    .filter(Boolean)
    .filter((m) => {
      if (m.systemAdminOnly && !visaPersonliga) return false;
      if (m.adminOnly && !isSystemAdmin) return false;
      if (m.tenantAdminOnly && !isTenantAdmin && !isSystemAdmin) return false;
      if (!m.moduleKey) return true;
      if (!effectiveModuleKeySet) return false;
      return effectiveModuleKeySet.has(m.moduleKey) && !ersattAvAnbudV2(m, effectiveModuleKeySet);
    });

  return (
    <div className={sectionClass}>
      <button
        type="button"
        className="kp-nav-section-header"
        onClick={onToggleCollapse}
        aria-expanded={!collapsed}
      >
        <span className="kp-nav-section-header-label">
          <Star className="kp-nav-section-icon" size={11} strokeWidth={2} aria-hidden="true" />
          Favoriter
        </span>
        <ChevronDown className="kp-nav-section-chevron" size={12} strokeWidth={2.5} aria-hidden="true" />
      </button>
      {items.length === 0 ? (
        <div className="kp-favorites-empty">
          <Star className="kp-favorites-empty-icon" size={11} strokeWidth={2} aria-hidden="true" />
          Klicka på stjärnan bredvid en modul för att lägga till den som favorit.
        </div>
      ) : (
        <div className="kp-nav-items">
          {items.map((module) => (
            <NavItem
              key={module.to}
              module={module}
              isFavorite={true}
              onToggleFavorite={onToggleFavorite}
              showStar={true}
              unreadCount={unreadCounts ? unreadCounts[module.label] || 0 : 0}
            />
          ))}
        </div>
      )}
    </div>
  );
}
